import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Link, Box } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';
import { CONTACT_US, FAQS, DESTINATIONS_AUSTRALIA, QCOM_PRIVACY_AND_SECURITY_URL, QCOM_TERMS_OF_USE_URL } from 'config';
import AppLink from 'components/AppLink';

const FooterLink = styled(Link)`
  display: block;
  font-size: ${themeGet('fontSizes.base')};
  padding-right: ${themeGet('space.4')};
  color: ${themeGet('colors.greys.steel')};
  text-decoration: underline;

  ${mediaQuery.minWidth.md} {
    display: inline-block;
  }
`;

FooterLink.displayName = 'FooterLink';

const Links = () => (
  <Fragment>
    <Box data-print-style="hidden">
      <FooterLink as={AppLink} to={CONTACT_US} data-testid="contactLink">
        Contact
      </FooterLink>
      <FooterLink href={QCOM_PRIVACY_AND_SECURITY_URL} data-testid="privacySecurityLink">
        Privacy &amp; Security
      </FooterLink>
      <FooterLink href={QCOM_TERMS_OF_USE_URL} data-testid="termOfUseLink">
        Terms of use
      </FooterLink>
      <FooterLink as={AppLink} to={DESTINATIONS_AUSTRALIA} data-testid="australianDestinationsLink">
        Australian destinations
      </FooterLink>
      <FooterLink as={AppLink} to={FAQS} data-testid="faqsLink">
        FAQs
      </FooterLink>
    </Box>
  </Fragment>
);

export default Links;
